import { connect } from 'react-redux'
import { compose } from 'redux'
import printConfig from '../../../print-config.json';
// import getPeriodeEndDate from '../../../functions/getPeriodeEndDate';
import getData from '../../../functions/getData';
import toJS from '../../../hoc/toJS';
import { THEME, PROGRAM_CLI_MOVIES_ITEMS, LOGO, PROGRAM_CINEMAS, CLI_CURRENT_CINEMA_ID, PROGRAM_PERFORMANCES, TRANSLATION, PROGRAM_ATTRIBUTES, CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FEATURES, FLYER_DATA, FRONT, PRINT_WEEKS } from '../../../constants/state';
import FlyerHeightContainer from './FlyerHeightContainer';
import FlyerPreview from '../presents/FlyerPreview';
import getFormatedDate from '../../../functions/getFormatedDate';
import { Component } from 'react';
import getOptionalCinemaId from '../../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId';
import filterAttributesByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterAttributesByCinema';
import sortAlphabetical from '../func/sortAlphabetical';
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../../../functions/getDateFromWeek';

const mapStateToProps = state => ({
    colors: getData(state, THEME),
    front: getData(state, FRONT),
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    performances: getData(state, PROGRAM_PERFORMANCES),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    logoData: getData(state, LOGO),
    hasFylerCaption: getData(state, [FEATURES, 'has_flyer_caption']),
    cinemas: getData(state, PROGRAM_CINEMAS),
    cinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    weeks: getData(state, PRINT_WEEKS),
    flyerServerData: getData(state, FLYER_DATA),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    translation: getData(state, TRANSLATION)
})

class FlyerPreviewContainer extends Component {
    constructor(props) {
        super(props)
    }

    getDates() {
        const { activeWeek, flyerData, translation } = this.props
        
        if(flyerData) {
            if(activeWeek === "custom") {
                const currentPeriodeStartDateCustom = flyerData.dateSettings && flyerData.dateSettings.startDate ? new Date(flyerData.dateSettings.startDate) : null
                const currentPeriodeEndDateCustom = flyerData.dateSettings && flyerData.dateSettings.endDate ? new Date(flyerData.dateSettings.endDate) : null
                const startYear = currentPeriodeStartDateCustom.getFullYear()
                const endYear = currentPeriodeEndDateCustom.getFullYear()
                
                return {
                    currentPeriodeStartDate: currentPeriodeStartDateCustom,
                    currentPeriodeEndDate:  currentPeriodeEndDateCustom,
                    formartedCurrentPeriodeStartDate:  getFormatedDate(currentPeriodeStartDateCustom, translation) + startYear,
                    formartedCurrentPeriodeEndDate:  getFormatedDate(currentPeriodeEndDateCustom, translation) + endYear
                }
                
            } else {
                const weeks = this.props.weeks
                const cWeek = weeks.find(w => w.isoWeek == activeWeek)
                const startDate = getFromWeekCinemaStartDate(cWeek.isoWeek, cWeek.year)
                const endDate = getFromWeekCinemaEndDate(cWeek.isoWeek, cWeek.year)

                // const year = new Date().getFullYear()
                // const currentWeek = new Date(year, 0, (1 + (activeWeek - 1) * 7));
                
                // while (currentWeek.getDay() !== 4) {
                //     currentWeek.setDate(currentWeek.getDate() + 1);
                // }
        
                // const currentPeriodeStartDate = currentWeek
                // const currentPeriodeEndDate = getPeriodeEndDate(currentWeek)
        
                return {
                    currentPeriodeStartDate: startDate.format(),
                    currentPeriodeEndDate:  endDate.format(),
                    formartedCurrentPeriodeStartDate: startDate.format('DD.MM.YYYY'),
                    formartedCurrentPeriodeEndDate: endDate.format('DD.MM.YYYY')
                    // formartedCurrentPeriodeStartDate:  getFormatedDate(currentPeriodeStartDate, translation) + year,
                    // formartedCurrentPeriodeEndDate:  getFormatedDate(currentPeriodeEndDate, translation) + year
                }
            }
        }
    }

    getStyles() {
        const { printFormat, landscape, colors, flyerData, front } = this.props
        const { accent_color_background, flyer_background, theme_colors } = colors
        const {custom_font_color, custom_font_color_color} = front

        const currentPrintFormat = _.findWhere(printConfig.formats, {path: printFormat, landscape: landscape})
        const currentPrintID = _.findKey(printConfig.formats, currentPrintFormat)
        const format = printConfig.formats[currentPrintID]
        const backgroundStyle = flyerData && flyerData.flyerSettings && flyerData.flyerSettings.flyerBackground ? flyerData.flyerSettings.flyerBackground : flyer_background ? `url("${flyer_background.url}")` : accent_color_background
        const textColorStyle = flyerData && flyerData.flyerSettings && flyerData.flyerSettings.flyerTextColor ? flyerData.flyerSettings.flyerTextColor : custom_font_color && custom_font_color_color ? custom_font_color_color : theme_colors === 'Dark' ? "#FFFFFF" : "#000000"

        let styles = {
            height: format.height,
            background: backgroundStyle,
            "--pmkinovar-flyer-text-color": textColorStyle
        }

        return {
            styles: styles
        }
    }

    getAttributes() {
        const { multicinemaMode, currentClientCinemaId, currentCinemaId, attributes } = this.props

        const optionalCinemaId = getOptionalCinemaId(multicinemaMode, currentCinemaId, currentClientCinemaId)
        const filteredAttributes = filterAttributesByCinema(attributes, optionalCinemaId)
        const sortedAttributes = sortAlphabetical(_.keys(filteredAttributes.technical))
        const captionAttributes = {}
        
        
        filteredAttributes && sortedAttributes && sortedAttributes.map((attributeId, index) => {
            const currentAlphabetNumber = (index + 10).toString(36).toUpperCase()
            const { name } = filteredAttributes.technical[attributeId]    
            
            if(name !== 'blocksubscriptions') {
                captionAttributes[attributeId] = {
                    captionLetter: currentAlphabetNumber,
                    captionName: name,
                    id: attributeId
                }
            }
        })

        return {
            captionAttributes: captionAttributes
        }
    }

    render() {
        const { activeWeek, side, section, currentCinemaId, translation, flyerData, colors, movies, performances, logoData, hasFylerCaption, cinemas, hideAttributes, flyerServerData } = this.props
        const { currentPeriodeStartDate, currentPeriodeEndDate, formartedCurrentPeriodeStartDate, formartedCurrentPeriodeEndDate } = this.getDates()
        const { styles } = this.getStyles()
        const { captionAttributes } = this.getAttributes()
        const cinemaData = cinemas[currentCinemaId]
        const items = flyerData.flyerStructure[side][section]

        return ( 
            <FlyerHeightContainer side={side} section={section} flyerData={flyerData}>
                <FlyerPreview
                    styles={styles}
                    side={side} 
                    hideAttributes={hideAttributes} 
                    section={section}
                    movies={movies}
                    performances={performances}
                    translation={translation}
                    flyerServerData={flyerServerData}
                    currentCinemaId={currentCinemaId}
                    cinemaData={cinemaData}
                    flyerData={flyerData}
                    captionAttributes={captionAttributes}
                    colors={colors}
                    iconsColor='light'
                    hasFylerCaption={hasFylerCaption}
                    currentPeriodeStartDate={currentPeriodeStartDate}
                    currentPeriodeEndDate={currentPeriodeEndDate}
                    formartedCurrentPeriodeStartDate={formartedCurrentPeriodeStartDate}
                    formartedCurrentPeriodeEndDate={formartedCurrentPeriodeEndDate}
                    items={items}
                    week={activeWeek}
                    logoData={logoData}
                />
            </FlyerHeightContainer>
        )
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(FlyerPreviewContainer)